import React from 'react';
import { useTranslation } from 'react-i18next';

import { Body } from '@swyftx/aviary/atoms/Typography';

const IdVerificationListOfForms: React.FC = () => {
  const { t } = useTranslation('onboarding');

  return (
    <Body size='medium' color='secondary' className='mb-32'>
      {t('steps.idVerification.subtitle')}
    </Body>
  );
};

export { IdVerificationListOfForms };
